import { Autocomplete, AutocompleteProps } from "@mui/material";

type DSAutocompleteProps<
  T,
  Multiple extends boolean | undefined = false,
> = AutocompleteProps<T, Multiple, false, false>;

const DSAutocomplete = <T, Multiple extends boolean | undefined = false>(
  props: DSAutocompleteProps<T, Multiple>,
) => {
  return <Autocomplete {...props} />;
};

export default DSAutocomplete;
